import moment from 'moment-timezone'
import { createSelector } from 'reselect'

export const availabilitySelector = ({ offerTimeSlotsModal }) => offerTimeSlotsModal.availability
export const isOpenSelector = ({ offerTimeSlotsModal }) => offerTimeSlotsModal.isOpen
export const eventTypeSelector = ({ offerTimeSlotsModal }) => offerTimeSlotsModal.eventType
export const initialEventTypeSelector = ({ offerTimeSlotsModal }) => offerTimeSlotsModal.initialEventType

const validateTimezone = (timezone) => timezone && moment.tz.zone(timezone)
const availabilityTimezoneSelector = createSelector(availabilitySelector, ({ timezone }) => timezone)
export const timezoneSelector = createSelector(
  eventTypeSelector,
  availabilityTimezoneSelector,
  (eventType, availabilityTimezone) => {
    if (validateTimezone(availabilityTimezone)) {
      return availabilityTimezone
    }
    if (!eventType) {
      return null
    }
    if (eventType.lockTimezoneEnabled && validateTimezone(eventType.lockTimezoneContent)) {
      return eventType.lockTimezoneContent
    }
    if (validateTimezone(eventType.availabilityTimezone)) {
      return eventType.availabilityTimezone
    }
    return null
  }
)
